import styled from '@emotion/styled';
import Box from '@mui/material/Box';

export const StyledPaymentBox = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
